<template>
  <header class="header">
    <div class="close__mobile--nav d-block d-md-none" v-on:click="closeNavigation">
      <img src="@/assets/close.svg" class="img-fluid" >
    </div>
    <div class="sidebar">
     <div class="menu__point menu_01" :class="{'active': active == 1}" v-on:click="moveToSection(1, 0)">
       <img src="@/assets/global/menu-item.png" class="img-fluid" >
       <div class="menu__name" v-html="$t('GLOBAL_MENU_01')"></div>
     </div>
      <div class="line"></div>
      <div class="menu__point menu_02" :class="{'active': active == 2}" v-on:click="moveToSection(2, 0)">
        <img src="@/assets/global/menu-item.png" class="img-fluid" >
        <div class="menu__name" v-html="$t('GLOBAL_MENU_02')"></div>
      </div>
      <div class="line"></div>
      <div class="menu__point menu_03" :class="{'active': active == 3}" v-on:click="moveToSection(3, 0)">
        <img src="@/assets/global/menu-item.png" class="img-fluid" >
        <div class="menu__name" v-html="$t('GLOBAL_MENU_03')"></div>
      </div>
      <div class="line"></div>
      <div class="menu__point menu_04" :class="{'active': active == 4}" v-on:click="moveToSection(4, 0)">
        <img src="@/assets/global/menu-item.png" class="img-fluid" >
        <div class="menu__name" v-html="$t('GLOBAL_MENU_04')"></div>
      </div>
      <div class="line"></div>
      <div class="menu__point menu_05" :class="{'active': active == 5}" v-on:click="moveToSection(5, 0)">
        <img src="@/assets/global/menu-item.png" class="img-fluid" >
        <div class="menu__name" v-html="$t('GLOBAL_MENU_05')"></div>
      </div>
      <div class="line"></div>
      <div class="menu__point menu_06" :class="{'active': active == 6}" v-on:click="moveToSection(6, 0)">
        <img src="@/assets/global/menu-item.png" class="img-fluid" >
        <div class="menu__name" v-html="$t('GLOBAL_MENU_06')"></div>
      </div>
      <div class="close__module d-block d-md-none" v-on:click="closeModule">
        <div class="menu__name" v-html="$t('GLOBAL_CLOSE')"></div>
      </div>
    </div>
  </header>
</template>

<script>
import { EventBus } from '../../main';
import Navigation from "@/components/partials/Navigation";

export default {
  name: "Header",
  components: {
    Navigation,
    EventBus
  },
  data() {
    return {
      lang: "",
      country: "",
      activeHover: -1,
      active: 1,
      highlightIndex: 0,
    }
  },
  watch: {
    '$store.state.currentNav': function() {
      this.active = this.$store.state.currentNav;
      this.highlightIndex = this.$store.state.currentNav;
      console.log(this.$store.state.currentNav)
    }
  },
  methods: {
    moveToSection(chapter, section) {
      let el;
      switch (chapter){
        case 1:
          el = document.getElementById('menu_01');
          this.active = 1;
          break;
        case 2:
          el = document.getElementById('menu_02');
          this.active = 2;
          break;
        case 3:
          el = document.getElementById('menu_03');
          this.active = 3;
          break;
        case 4:
          el = document.getElementById('menu_04');
          this.active = 4;
          break;
        case 5:
          el = document.getElementById('menu_05');
          this.active = 5;
          break;
        case 6:
          el = document.getElementById('menu_06');
          this.active = 6;
          break;

      }
      el.scrollIntoView({behavior: "smooth"});
    },

    closeModule(){
      window.open('/'+ this.country + '_' + this.lang + '/brand-choice/' ,"_self")
    },
    closeNavigation(){
      document.querySelector('header').classList.remove('active');
    }

  },
  mounted() {
    this.lang = this.$store.getters.lang;
    this.country = this.$store.getters.country;


  }
}
</script>

<style scoped>

</style>